import * as React from 'react';
import './StressBarometerUserPanel.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import StressBarometerService from '../../../../services/StressBarometerService';
import AdminService from '../../../../services/AdminService';
import { IUser } from '../../../../interfaces/IUser';
import UserSearchPopup from '../../../userSearchPopup/UserSearchPopup';
import StressBarometer from '../StressBarometer';

export interface IProps {
  appStore?: AppStore;
  id?: string;
}

export interface IState {
  searchValueUsers?: string;
  loadingUsers?: boolean;
  usersToRender?: JSX.Element[];
  user?: IUser;
  selectedPart?: "areas" | "importance" | "values" | "result";
  saving?: boolean;
  showImportance?: boolean;
  showValue?: boolean;
  showStress?: boolean;
  sortBy?: "importance" | "value" | "stress";
}

@inject('appStore')
@observer
export default class StressBarometerUserPanel extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      selectedPart: "areas",
      showImportance: true,
      showValue: true,
      showStress: true,
      sortBy: "stress"
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.id !== this.props.id && this.props.appStore!.stressBarometerToFillIn?.userId) {
      this.getUser();
      if (this.props.appStore!.stressBarometerToFillIn?.areas?.[0]?.value) {
        this.setState({ selectedPart: "result" });
      } else {
        if (this.validate(this.state.selectedPart) && !this.props.appStore!.stressBarometerToFillIn?.allowUserToEditAreas) {
          this.setState({ selectedPart: "importance" });
        }
      }
    }
  }

  getUser(): void {
    AdminService.getUserNameFromId(this.props.appStore!.stressBarometerToFillIn?.userId).then((user: IUser) => {
      this.setState({ user });
    });
  }

  private validate(part: "areas" | "importance" | "values" | "result"): boolean {
    switch (part) {
      case "areas":
        return this.props.appStore!.stressBarometerToFillIn?.areas?.every(area => area.title && area.title.trim() !== '');
      case "importance":
        return this.props.appStore!.stressBarometerToFillIn?.areas?.every(area => area.importance);
      case "values":
        return this.props.appStore!.stressBarometerToFillIn?.areas?.every(area => area.value);
      default:
        return false;
    }
  }

  render() {
    return (
      <div>
        <div
          className="stressBarometerUserPanelWrapper"
          style={{
            visibility: this.props.appStore!.stressBarometerToFillIn != undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            this.props.appStore!.stressBarometerToFillIn = undefined;
          }}
        />
        <div
          className="stressBarometerUserPanel"
          style={{
            right: this.props.appStore!.stressBarometerToFillIn != undefined ? 0 : -820
          }}
        >
          <div className="editPanelCloseBtn"
            onClick={() => {
              this.props.appStore!.stressBarometerToFillIn = undefined;
              this.setState({ selectedPart: "areas" });
            }}
          />
          <h1>{this.props.appStore!.stressBarometerToFillIn?.title}</h1>
          {this.state.selectedPart === "areas" &&
            <>
              <h3>{`1) ${window.loc.strings.stressBarometerAreas}`}</h3>
              {this.props.appStore!.stressBarometerToFillIn?.areas?.map((area, index) => (
                <div key={index} className="roadmapQuestion">
                  <input
                    type="text"
                    disabled={this.props.appStore!.stressBarometerToFillIn?.allowUserToEditAreas ? false : true}
                    value={this.props.appStore!.stressBarometerToFillIn?.areas?.[index].title}
                    onChange={(event: any) => {
                      if (this.props.appStore!.stressBarometerToFillIn?.areas) {
                        this.props.appStore!.stressBarometerToFillIn.areas[index].title = event.target.value;
                        this.props.appStore!.stressBarometerToFillIn = { ...this.props.appStore!.stressBarometerToFillIn };
                      }
                    }}
                  />
                </div>
              ))}
            </>
          }
          {this.state.selectedPart === "importance" &&
            <>
              <h3>{`2) ${window.loc.strings.stressBarometerAreaImportance}`}</h3>
              {this.props.appStore!.stressBarometerToFillIn?.areas?.map((area, index) => (
                <div key={index} className="roadmapQuestion">
                  <div className="inputFieldLabel">{area.title}</div>
                  <RatingInput
                    value={area.importance}
                    onChange={(newValue: number) => {
                      if (this.props.appStore!.stressBarometerToFillIn?.areas) {
                        this.props.appStore!.stressBarometerToFillIn.areas[index].importance = newValue;
                        this.props.appStore!.stressBarometerToFillIn = { ...this.props.appStore!.stressBarometerToFillIn };
                      }
                    }}
                  />
                </div>
              ))}
            </>
          }
          {this.state.selectedPart === "values" &&
            <>
              <h3>{`3) ${window.loc.strings.stressBarometerAreaValue}`}</h3>
              {this.props.appStore!.stressBarometerToFillIn?.areas?.map((area, index) => (
                <div key={index} className="roadmapQuestion">
                  <div className="inputFieldLabel">{area.title}</div>
                  <RatingInput
                    value={area.value}
                    onChange={(newValue: number) => {
                      if (this.props.appStore!.stressBarometerToFillIn?.areas) {
                        this.props.appStore!.stressBarometerToFillIn.areas[index].value = newValue;
                        this.props.appStore!.stressBarometerToFillIn = { ...this.props.appStore!.stressBarometerToFillIn };
                      }
                    }}
                  />
                </div>
              ))}
            </>
          }
          {this.state.selectedPart === "result" &&
            <div style={{ float: "left" }}>
              <StressBarometer
                showImportance={this.state.showImportance}
                showValue={this.state.showValue}
                showStress={this.state.showStress}
              />
              <div id="StressBarometerControls" className='stressBarometerControls'>
                <div>
                  <label className='stressBarometerControlLabel' style={{ marginRight: '20px' }}>
                    <input
                      type="checkbox"
                      checked={this.state.showStress}
                      onChange={() => this.setState({ showStress: !this.state.showStress })}
                      style={{ marginRight: '5px', accentColor: '#e63a3a', width: '16px', height: '16px' }}
                    />
                    {window.loc.strings.stressBarometerLabelStress}
                  </label>
                  <label className='stressBarometerControlLabel' style={{ marginRight: '20px' }}>
                    <input
                      type="checkbox"
                      checked={this.state.showImportance}
                      onChange={() => this.setState({ showImportance: !this.state.showImportance })}
                      style={{ marginRight: '5px', accentColor: '#7a12d4', width: '16px', height: '16px' }}
                    />
                    {window.loc.strings.stressBarometerLabelImportance}
                  </label>
                  <label className='stressBarometerControlLabel' style={{ marginRight: '20px' }}>
                    <input
                      type="checkbox"
                      checked={this.state.showValue}
                      onChange={() => this.setState({ showValue: !this.state.showValue })}
                      style={{ marginRight: '5px', accentColor: '#3ab5e6', width: '16px', height: '16px' }}
                    />
                    {window.loc.strings.stressBarometerLabelValue}
                  </label>
                </div>
                <select
                  className='stressBarometerSortDropdown'
                  value={this.state.sortBy}
                  onChange={(e) => this.setState({ sortBy: e.target.value as any })}
                >
                  <option value="" disabled>{window.loc.strings.stressBarometerSortBy}</option>
                  <option value="importance">{window.loc.strings.stressBarometerSortByImportance}</option>
                  <option value="value">{window.loc.strings.stressBarometerSortByValue}</option>
                  <option value="stress">{window.loc.strings.stressBarometerSortByStressLevel}</option>
                </select>
              </div>
              {this.props.appStore!.stressBarometerToFillIn?.areas?.sort((a: any, b: any) => {
                const getValue = (area: any, field: string) => {
                  if (field === 'importance') return area.importance;
                  if (field === 'value') return area.value;
                  if (field === 'stress') return Math.abs(area.importance - area.value);
                  return 0;
                };
                return getValue(b, this.state.sortBy) - getValue(a, this.state.sortBy);
              }).map((area, index) => {
                const stressLevel = Math.abs(area.importance - area.value);
                return (
                  <div key={index} className="sbResultArea">
                    <div className="sbAreaTitle">{area.title}</div>
                    {this.state.showStress &&
                      <div className="sbBarRow">
                        <div className="sbBarLabel">{window.loc.strings.stressBarometerSortByStressLevel}</div>
                        <div className="sbBarTrack">
                          <div className="sbBarFill sbBarStress" style={{ width: `${(stressLevel / 10) * 100}%` }} />
                        </div>
                        <div className="sbBarValue">{stressLevel}</div>
                      </div>
                    }
                    {this.state.showImportance &&
                      <div className="sbBarRow">
                        <div className="sbBarLabel">{window.loc.strings.stressBarometerLabelImportance}</div>
                        <div className="sbBarTrack">
                          <div className="sbBarFill sbBarImportance" style={{ width: `${(area.importance / 10) * 100}%` }} />
                        </div>
                        <div className="sbBarValue">{area.importance}</div>
                      </div>
                    }
                    {this.state.showValue &&
                      <div className="sbBarRow">
                        <div className="sbBarLabel">{window.loc.strings.stressBarometerLabelValue}</div>
                        <div className="sbBarTrack">
                          <div className="sbBarFill sbBarValueFill" style={{ width: `${(area.value / 10) * 100}%` }} />
                        </div>
                        <div className="sbBarValue">{area.value}</div>
                      </div>
                    }
                  </div>
                );
              })}
            </div>
          }
          {this.state.selectedPart !== "result" && !this.state.saving &&
            <div
              className='newStressBarometerButton'
              style={{
                clear: "both",
                float: "left",
                marginTop: "20px",
                backgroundColor: "#7a12d4",
                color: "white",
                opacity: this.validate(this.state.selectedPart) ? 1 : 0.5,
              }}
              onClick={() => {
                if (this.validate(this.state.selectedPart)) {
                  switch (this.state.selectedPart) {
                    case "areas":
                      this.setState({ selectedPart: "importance" });
                      break;
                    case "importance":
                      this.setState({ selectedPart: "values" });
                      break;
                    case "values":
                      this.setState({ saving: true });
                      StressBarometerService.updateStressBarometer(this.props.appStore!.stressBarometerToFillIn).then(() => {
                        this.setState({ selectedPart: "result", saving: false });
                      });
                      break;
                    case "result":

                      break;
                  }
                }
              }}
            >
              {window.loc.strings.next}
            </div>
          }
        </div>
        {
          this.state.usersToRender?.length > 0 &&
          <UserSearchPopup
            users={this.state.usersToRender}
            close={() => {
              this.setState({
                usersToRender: [],
                searchValueUsers: undefined,
              }, () => this.forceUpdate());
            }}
          />
        }
      </div >
    );
  }
}

export interface IRatingInputProps {
  value?: number;
  onChange?: (value: number) => void;
}

@inject('appStore')
@observer
export class RatingInput extends React.Component<IRatingInputProps, {}> {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='ratingInput' style={{
        display: 'flex',
        width: '100%',
        gap: '2px',
        justifyContent: 'space-between'
      }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
          <button
            key={rating}
            className={`ratingButton ${this.props.value === rating ? 'selected' : ''}`}
            style={{
              flex: 1,
              height: '35px',
              width: '35px',
              borderRadius: '6px',
              backgroundColor: this.props.value === rating ? '#7a12d4' : '#fff',
              color: this.props.value === rating ? '#fff' : '#333',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'all 0.2s ease',
              textAlign: 'center',
              padding: 0
            }}
            onClick={() => this.props.onChange?.(rating)}
            onMouseEnter={(e) => {
              if (this.props.value !== rating) {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.borderColor = '#7a12d4';
              }
            }}
            onMouseLeave={(e) => {
              if (this.props.value !== rating) {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.borderColor = '#ddd';
              }
            }}
          >
            {rating}
          </button>
        ))}
      </div>
    );
  }
}